import { Dictionary, filter, orderBy, reduce, take } from "lodash";
import { HighlightedItemProps } from "@/shared/widgets/HighlightedItemsList";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";

export const getTopDimensionsBySection = (
  dimensions: Dictionary<DimensionWithScores[]>,
  topCount = 3
) =>
  reduce(
    dimensions,
    (result, dimensionScores, section) => {
      const topDimensions = take(
        orderBy(
          filter(dimensionScores, (d) => !!d.parentId),
          "score.value",
          "desc"
        ),
        topCount
      );

      return {
        ...result,
        [section]: topDimensions.map((d) => ({
          label: d.title,
          description: d.description,
          id: d.id,
        })),
      };
    },
    {} as Dictionary<HighlightedItemProps[]>
  );
